import { Injectable } from '@angular/core';
import { ApiService, HttpMethod } from '../api/api.service';
import { UserActivityLog } from '../../models/user-activity.model';

@Injectable({
  providedIn: 'root'
})
export class UserActivityService {

  constructor(
    private apiService: ApiService
  ) { }

  public async getForUser(userId: number) {
    return this.apiService.call<{ data: UserActivityLog[] }>(HttpMethod.GET, `activity/${userId}`);
  }  

}
